import React from 'react';
import { motion } from 'framer-motion';
import Container from '../common/container';

export default function Industries() {
  const industries = [
    { name: 'Finance & Insurance', icon: '💳' },
    { name: 'Hospitality & Travel', icon: '✈️' },
    { name: 'Retail & E-commerce', icon: '🛍️' },
    { name: 'Real Estate', icon: '🏠' },
    { name: 'Education', icon: '📚' },
    { name: 'Government & Nonprofits', icon: '🏛️' },
    { name: 'Agriculture', icon: '🌾' },
    { name: 'Automotive', icon: '🚗' }
  ];

  return (
    <section className="py-20 bg-white">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Industries We Serve</h2>
          <p className="text-lg text-gray-600">
            Our platform is designed to meet the unique needs of businesses across diverse sectors.
          </p>
        </motion.div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {industries.map((industry, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: 0.05 * index }}
              className="bg-gray-50 hover:bg-primary/5 rounded-xl p-6 text-center transition-colors duration-300"
            >
              <div className="text-3xl mb-3">{industry.icon}</div>
              <div className="font-medium">{industry.name}</div>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
}